import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';
import { Service } from '@src/api/tenant/auth/tenantAuthStatusApiClient';
import { AuthCompany } from '@src/api/types/userCompany';
import { CompanyRoleType } from '@src/enum/companyRoleEnum';

export type LoginUser = {
  id: number;
  is_admin: boolean;
  family_name: string;
  first_name: string;
  avatar_url: string;
  enabled: boolean;
  role: Role;
};

type Role = {
  code: CompanyRoleType;
};

export type Tenant = {
  required_user_approval: boolean;
  service: Service;
};

export type DisplayNameStatus = {
  requires_display_name_update: boolean;
};

export type AuthStatusResponse = {
  is_login: boolean;
  user: LoginUser | null;
  top_page_link: string;
  company: AuthCompany;
  tenant: Tenant;
  display_name_status: DisplayNameStatus;
};

export const companyAuthStatusApiClient = {
  status: async (): Promise<ApiResult<AuthStatusResponse>> => {
    return await axiosClient.get('/company/auth/status');
  },
};
